import AgeCode from '../ageCode/ageCode';
import PilotInfoContainer from '@components/atoms/container/pilotInfoContainer';
import Rating from '../rating/rating';
import Colors from '@shared/assets/style/default/color';

interface Props {
  ageCode?: string;
  rating?: number;
}

export default function PilotInfo({ ageCode, rating }: Props) {
  return (
    <PilotInfoContainer>
      <Rating
        color={Colors['border']['rating']}
        percentage={(rating || 0) / 5}
        rating={rating?.toString()}
      />
      <AgeCode ageCode={ageCode} />
    </PilotInfoContainer>
  );
}
